import { createProfileModel } from 'models/ProfileModel';

export default createProfileModel;
